module.exports = __webpack_public_path__ + "img/ethereum.56d2c835.svg";